// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1wE73","info":"UpdateTermsInfo_info__kdeUw"};